import { toast } from 'sonner';

export const exportToCSV = (membres, filename = 'membres_export.csv') => {
  // Collecter TOUS les champs présents dans les données pour un export complet
  const allFieldsSet = new Set();
  membres.forEach(m => {
    Object.keys(m).forEach(k => {
      // Exclure les champs internes/calculés du frontend
      if (!k.startsWith('_') && k !== 'ftpe_expiration') {
        allFieldsSet.add(k);
      }
    });
  });

  // Champs prioritaires en premier, puis le reste par ordre alphabétique
  const priorityFields = [
    'id', 'numero_membre', 'raison_sociale', 'nom', 'prenom', 'email', 'telephone',
    'siret', 'entreprise', 'territoire', 'status', 'rcds_status', 'ftpe_status', 'dos_status',
    'cooper_id', 'created_at', 'created_by', 'created_by_name', 'created_by_role', 'updated_at'
  ];
  
  const orderedFields = [];
  priorityFields.forEach(f => {
    if (allFieldsSet.has(f)) {
      orderedFields.push(f);
      allFieldsSet.delete(f);
    }
  });
  // Ajouter les champs restants par ordre alphabétique
  [...allFieldsSet].sort().forEach(f => orderedFields.push(f));

  const rows = membres.map(m => {
    return orderedFields.map(field => {
      const val = m[field];
      if (val === undefined || val === null) return '';
      // Préserver les dates ISO telles quelles — NE PAS formater
      if (typeof val === 'object' && val instanceof Date) return val.toISOString();
      if (typeof val === 'object') return JSON.stringify(val);
      return String(val);
    });
  });

  const esc = cell => `"${String(cell).replace(/"/g, '""')}"`;
  const csvContent = [orderedFields.join(';'), ...rows.map(row => row.map(esc).join(';'))].join('\n');

  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
  
  toast.success(`${membres.length} membres exportés (${orderedFields.length} champs)`);
};
